export enum ChannelMonitoringStatus {
    UNKNOWN = 'UNKNOWN',
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE',
    SCHEDULED = 'SCHEDULED',
    CREATED = 'CREATED',
}
